package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2024_04_12_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our heroes travel all day and setup camp at 7pm. A dragon is seen landing near Zedj during watch #3.")
    }
}
